import React, { useState, useEffect, useRef } from 'react'
import { MwSpinner, MwSwitch } from '../../../components/ui'
import { useDelete } from '../../../hooks'
import { CiViewList } from 'react-icons/ci'
import { MdEdit } from 'react-icons/md'
import { AiOutlineDelete } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import DeleteConfirmationModal from '../../../components/OsRequisition/RequisitionComponents/DeleteConfirmationModal'
import ActionsDropdown from '../../../components/common/ActionsDropdown'
import ActiveIndicator from '../../../components/common/ActiveIndicator'

const WarehousesListItem = ({item, onEdit, onView, setItems, index}) => {
    const [t,i18n ] = useTranslation('global')
    const isRTL = i18n.dir() === 'rtl';
    const [isActive,setIsActive] = useState(false)
    const [showActions, setShowActions] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const actionsRef = useRef(null)
    const { deleteItem, loading: deleteLoading } = useDelete()

    useEffect(() =>{
        if(item?.is_active){
            setIsActive(item?.is_active)
        }
    },[item]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (actionsRef.current && !actionsRef.current.contains(event.target)) {
                setShowActions(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const handleConfirmDelete = async () => {
        await deleteItem(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${item.id}`)
        setDeleteModalOpen(false)

        setItems(prevData => ({
            ...prevData,
            data: prevData.data.filter(listItem => listItem.id !== item.id)
        }))
    }

    if(deleteLoading) {
        return (
            <div className="flex items-center justify-center w-full p-4">
                <MwSpinner className="text-blue-500" />
            </div>
        )
    }
    
    return (
        <div 
        className={`grid grid-cols-12 gap-3 border-t px-4 py-2   items-center hover:bg-indigo-50 hover:font-bold relative cursor-pointer ${
          showActions ? '' : 'hover:bg-indigo-50/40 hover:font-bold'
        }`}
        onClick={(e) => {
          onView(item.id);
          e.stopPropagation();
        }}
      >
      
            {/* Index */}
            <div className="col-span-1  text-center  text-xs text-[#251658]">
                {index + 1}
            </div>
            
            {/* Code */}
            <div className="col-span-2 text-center   text-xs text-[#251658]">
                {item.code}
            </div>
            
            {/* Name and Address */}
            <div className="col-span-4  ">
                <div className="text-xs text-[#251658]  ">
                    <span className="text-[#251658] ml-4">{item.name_ar}</span>
                    {/* <span>{item.name_en}</span> */}
                </div>
            </div>
            <div className="col-span-2  ">
               
                <div className="text-[14px]  text-[#251658] mt-1">
                    {item.address}  
                </div>
            </div>
            
            {/* Creation Date */}
            <div className="col-span-2  text-center  text-xs text-[#251658]">
                {new Date(item.created_at).toLocaleDateString('en-EG')}
            </div>

            {/* Actions */}
            <div className="col-span-1 items-center flex justify-end   text-xs text-[#251658] relative">
            <ActiveIndicator active={item.is_active} />
 

                <ActionsDropdown
                isRTL={isRTL}
                onView={(id) => {
                    onView(id);
                }}
                onEdit={(id) => {
                    onEdit(id);
                }}
                onDelete={() => {
                    setDeleteModalOpen(true);
                }}
                itemId={item.id}
                viewText={t('stocktaking.view')}
                editText={t('requisition.edit')}
                deleteText={t('stocktaking.delete')}
                />

                <DeleteConfirmationModal
                    isOpen={deleteModalOpen}
                    onClose={() => setDeleteModalOpen(false)}
                    onConfirm={handleConfirmDelete}
                    loading={false}
                />
            </div>
        </div>
    );
}

export default WarehousesListItem